// extracted by mini-css-extract-plugin
export default {"submenuItem":"SubmenuItem_submenuItem__Grppr","spin":"SubmenuItem_spin__-iUGa","fadeInDown":"SubmenuItem_fadeInDown__F6lT-"};